import React from "react";
import ReactHtmlParser from "react-html-parser";
import ProductSizeList from "./productSizeList";
import ProductMultiSize from "./productMultiSize";
import ModelDetails from "@/components/product/modelDetails";
import { ProductImageVariant } from "../../types";

const ProductSize = ({
  activeSizeType,
  isProductMultisize,
  sizeShown,
  modelProfile,
  productSizes
}) => (
  <div className="product_sizes_container">
    {isProductMultisize && activeSizeType ? (
      <ProductMultiSize activeSizeType={activeSizeType} />
    ) : (
      <ProductSizeList
        productSizes={productSizes[0].variants}
        isMultipleSize={false}
        isActive
      />
    )}
    {modelProfile && modelProfile?.type === ProductImageVariant.Real && (
      <ModelDetails modelProfile={modelProfile} />
    )}
    {sizeShown?.values && (
      <div className="mobile_size_message">
        <div>
          <img
            src={sizeShown?.values?.[0].icon}
            alt="size helper text"
            className="ruler-icon"
          />
        </div>
        <div>{ReactHtmlParser(sizeShown?.values?.[0].shortText)}</div>
      </div>
    )}
  </div>
);

export default ProductSize;
